<template>
  <div class="d-flex flex-row align-items-start justify-content-between wd-100p-force">
    <div class="card wd-100p-force mx-wd-100p-force">
      <div class="card-body pd-2 stats-block-parent">
        <div class="d-flex flex-row align-items-center justify-content-between mg-rem-b-4 wd-100p-force">
          <div class="d-flex flex-row align-items-center">
            <div class="input-group filter-input-group wd-180-force">
              <span class="input-group-text">От:</span>
              <input type="date" class="form-control" v-model="filters.date_from">
              <span class="input-group-text" v-on:click="filters.date_from = ''" style="cursor: pointer;">
                <vue-feather type="x" :size="14" :style="{ 'color': filters.date_from ? 'var(--cui-dark)' : 'var(--cui-light)' }"></vue-feather>
              </span>
            </div>
            <div class="input-group filter-input-group mg-rem-l-2 wd-180-force">
              <span class="input-group-text">До:</span>
              <input type="date" class="form-control" v-model="filters.date_to">
              <span class="input-group-text" v-on:click="filters.date_to = ''" style="cursor: pointer;">
                <vue-feather type="x" :size="14" :style="{ 'color': filters.date_to ? 'var(--cui-dark)' : 'var(--cui-light)' }"></vue-feather>
              </span>
            </div>
            <button class="btn btn-sm btn-primary mg-rem-l-3" :disabled="!isRangeValid" @click="reload()">Обновить</button>
          </div>
          <icon-button :padding="'5px 10px'"
                       :disabled="!(flatItems && flatItems.length)"
                       :label="'Скачать Excel'"
                       :class-name="'btn btn-sm  tx-12 btn-outline-info'"
                       icon="download"
                       v-on:click="downloadExcel()"
          >
          </icon-button>
        </div>
        <div class="stats-block-expenses wd-100p-force">
          <data-table :columns="columns" :items="flatItems" :loading="loading" :show-search="false" :items-cnt="count"></data-table>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
  .stats-block-expenses table {
    table-layout: fixed;
  }
</style>

<script>
import {h} from "vue";
import DistributionClass from "@/entities/Distributions/DistributionClass";
import DataTable from "@/elements/Table";
import IconButton from "@/elements/IconLink";
import {createConfirmDialog} from "vuejs-confirm-dialog";
import DialogDownloadExpenses from "@/elements/DialogDownloadExpenses";
import NumberFormatted from "@/elements/NumberFormatted.vue";
import VueFeather from "vue-feather";

export default {
  components: {IconButton, DataTable, NumberFormatted, VueFeather },
  data() {
    return {
      Distributions: null,
      loading: false,
      count: 1,

      toggleInProgress: false,

      columns: [
        {
          header: 'Промежуток / Проект / Оператор',
          value: (item) => {
            if (item.__type === 'month') {
              return h('div', {class: 'd-flex flex-row align-items-center wd-100p-force'}, [
                h(VueFeather, {
                  type: this.isMonthExpanded(item.period) ? 'minus-square' : 'plus-square',
                  size: 16,
                  style: 'cursor: pointer; margin-right: 6px; color: var(--cui-primary);',
                  onClick: () => this.toggleMonth(item.period)
                }),
                h('span', {class: 'tx-secondary wd-fit-content', style: 'margin-right: 6px;'}, item.days ?? ''),
                h('span', {}, (item.period || '').replaceAll('.', '-'))
              ]);
            }
            if (item.__type === 'project') {
              const key = this.projectKey(item.period, item.project_id);
              return h('div', {class: 'd-flex flex-row align-items-center wd-100p-force', style: 'padding-left: 24px;'}, [
                h(VueFeather, {
                  type: this.isProjectExpanded(key) ? 'minus-square' : 'plus-square',
                  size: 16,
                  style: 'cursor: pointer; margin-right: 6px; color: var(--cui-primary);',
                  onClick: () => this.toggleProject(key)
                }),
                h('span', {class: 'tx-semibold'}, item.project_name || '—')
              ]);
            }
            // operator
            return h('div', {class: 'd-flex flex-row align-items-center wd-100p-force', style: 'padding-left: 48px;'}, [
              h('span', {}, item.operator || '—')
            ]);
          }
        },
        {
          header: 'Расходы',
          value: (item) => { return h(NumberFormatted, {class: 'wd-100p-force text-align-center', value: item.expense}) }
        }
      ],

      rawItems: [],
      flatItems: [],
      expandedMonths: new Set(),
      expandedProjects: new Set(),

      items: [],
      filters: { date_from: '', date_to: '' }
    }
  },
  computed: {
    isRangeValid() {
      if (!this.filters.date_from || !this.filters.date_to) return true;
      return this.filters.date_from <= this.filters.date_to;
    }
  },
  methods: {
    buildQueryParams() {
      const p = {};
      if (this.filters.date_from) p.date_from = this.filters.date_from;
      if (this.filters.date_to) p.date_to = this.filters.date_to;
      if (p.date_from && p.date_to && p.date_from > p.date_to) {
        delete p.date_from;
        delete p.date_to;
      }
      return p;
    },
    init() { this.reload(); },
    reload() {
      const params = this.buildQueryParams();
      this.loading = true;
      this.Distributions.expenses((items) => {
        // items: flat rows from API with fields: period, days, project_id, project_name, operator, expense
        this.rawItems = Array.isArray(items) ? items : [];
        this.rebuildHierarchy();
        this.loading = false;
      }, () => { this.loading = false; }, params);
    },
    downloadExcel() {
      if (this.rawItems.length) {
        const { reveal } = createConfirmDialog(h(DialogDownloadExpenses));
        reveal({ date_from: this.filters.date_from || '', date_to: this.filters.date_to || '' });
      }
    },

    isMonthExpanded(period) { return this.expandedMonths.has(period); },
    toggleMonth(period) {
      if (this.expandedMonths.has(period)) this.expandedMonths.delete(period); else this.expandedMonths.add(period);
      this.rebuildHierarchy();
    },
    projectKey(period, project_id) { return `${period}:${project_id === null || project_id === undefined ? 'null' : project_id}`; },
    isProjectExpanded(key) { return this.expandedProjects.has(key); },
    toggleProject(key) {
      if (this.expandedProjects.has(key)) this.expandedProjects.delete(key); else this.expandedProjects.add(key);
      this.rebuildHierarchy();
    },

    rebuildHierarchy() {
      // group by period
      const byPeriod = this.rawItems.reduce((acc, it) => {
        (acc[it.period] = acc[it.period] || []).push(it);
        return acc;
      }, {});

      // sort periods desc by YYYY-MM derived from period MM.YYYY
      const periodOrder = Object.keys(byPeriod).sort((a, b) => {
        const [am, ay] = a.split('.');
        const [bm, by] = b.split('.');
        const aNum = parseInt(ay) * 100 + parseInt(am);
        const bNum = parseInt(by) * 100 + parseInt(bm);
        return bNum - aNum;
      });

      const flat = [];
      periodOrder.forEach((period) => {
        const items = byPeriod[period];
        // month sum
        const monthExpense = items.reduce((s, it) => s + (parseFloat(it.expense) || 0), 0);
        const days = (items[0] && items[0].days) ? items[0].days : '';
        flat.push({ __type: 'month', period, days, expense: monthExpense });

        if (!this.isMonthExpanded(period)) return;

        // group by project_id within period
        const byProject = items.reduce((acc, it) => {
          const key = this.projectKey(period, it.project_id);
          if (!acc[key]) acc[key] = { project_id: it.project_id, project_name: it.project_name, rows: [] };
          acc[key].rows.push({ operator: it.operator, expense: it.expense });
          return acc;
        }, {});

        // sort projects by project_name asc
        const projectKeys = Object.keys(byProject).sort((ka, kb) => {
          const aName = (byProject[ka].project_name || '').toString();
          const bName = (byProject[kb].project_name || '').toString();
          return aName.localeCompare(bName);
        });

        projectKeys.forEach((key) => {
          const p = byProject[key];
          const projExpense = p.rows.reduce((s, r) => s + (parseFloat(r.expense) || 0), 0);
          flat.push({ __type: 'project', period, project_id: p.project_id, project_name: p.project_name, expense: projExpense });

          if (!this.isProjectExpanded(key)) return;

          // sort operators asc
          const ops = p.rows.slice().sort((a, b) => (a.operator || '').localeCompare(b.operator || ''));
          ops.forEach((r) => {
            flat.push({ __type: 'operator', period, project_id: p.project_id, operator: r.operator, expense: r.expense });
          });
        });
      });

      this.flatItems = flat;
    }
  },
  mounted() {
    this.Distributions = new DistributionClass(this);
    this.init();
  }
}
</script>